import React from 'react';
import '../assets/style/select.scss';
import coutriesData from "../assets/js/country"
import { Tooltip} from 'element-react/next';

export default class CountryDom extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			data: {},
			index: 0,
			city: false,
			current: []
		};
	}
	componentDidMount() {

		this.setState({
			current: coutriesData.chinese[0].list,
			data: coutriesData
		})
	}
	changeArea(i) {
		this.state.index = i
		this.setState({
			current: coutriesData.chinese[i].list
		})
	}
	render() {
		let areas = coutriesData.chinese.map((item, key) => {
			return (
				<span style={{fontSize:8+'px',flex:1 ,textAlign:"center"}} className={this.state.index === key ? "active" : "item"} onClick={() => {
					this.changeArea(key)
				}} key={key}>{item.area}</span>
			)

		})
		let cityOption = this.state.current.map((item, key) => {
			return (<Tooltip effect="dark" content={item.name} placement="top"><span style={{ fontSize: 12 + 'px'}} key={key} onClick={
				() => {
					this.props.parent.state.countryName = item.name
					this.props.parent.state.countryValue = item.value
					let obj = {
						value: item.value,
						name: item.name
					}
					this.props.parent.getCountryMsg(this, obj)
				}
			} value={item.value}>{item.name}</span></Tooltip>)

		})
		let status = this.props.parent.state.countryStatus
		return (
			<div className={status == true ? "pms-select-on" : "pms-select-off"}>
				<div className="area">
					{areas}
				</div>
				<div className='pms-select-span'>
					{cityOption}
				</div>
			</div>

		)
	}
}



// WEBPACK FOOTER //
// ./public/views/selectCountry.js